// import * as apis from '@apis'

const Clues = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'newsplan-clues',
      'docLib': 1, // 文档库ID
      'docTypeCode': 'NPCLUES'
    },
    censorshipTableData: {},
    issuesData: {}
  },
  getters: {},
  mutations: {},
  actions: {}
}

export default Clues
